import { useFetchMutation } from "common/queries/hooks";
import { PaymentErrorData } from "common/types/payments";
import { FetchError } from "common/fetch/errors";

import { urls } from "./constants";
import { PatientCareBulkUpdateData } from "../types";

const noop = () => null;

export const usePatientCareBulkUpdateMutation = ({
  onSuccess = noop,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (
    error: FetchError<PatientCareBulkUpdateData, PaymentErrorData>,
    data: PatientCareBulkUpdateData,
  ) => void;
}) => {
  return useFetchMutation<
    PatientCareBulkUpdateData,
    void,
    void,
    PatientCareBulkUpdateData,
    FetchError<PatientCareBulkUpdateData, PaymentErrorData>
  >({
    fetch: (body) => ({ method: "PATCH", url: urls.bulkCarePlans(), body }),
    config: {
      onSuccess: () => {
        onSuccess();
      },
      onError,
    },
  });
};
